<section>
	<article class="container">
		<div class="row">
			<!-- Primer Columna Footer -->
			<div class="col-12 col-lg-6 p-4">
				<div class="row">
					<div class="col-4">
						<img class="w-100" src="./assets/imgs/logo-color.webp" alt="Logo Tadeo Viajes">
					</div>
					<div class="col-10 mb-2">
						<!-- <p class="texto-footer p-2">
							Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia mollitia neque culpa sint numquam atque explicabo dolore, enim, nesciunt nostrum ipsa est natus molestiae alias eligendi, autem at temporibus doloremque!
						</p> -->
						<div *ngFor="let item of footer_list" class="w-100">
							<p class="texto-footer  mb-1" *ngFor="let texto of item.mensaje_general.split('\n')">{{texto}}</p>
						</div>


					</div>
					<div class="col-12 mb-2">
						<div *ngFor="let item of footer_list" class="w-100">
							<h5 class="title-followers  mb-1" *ngFor="let texto of item.numero_seguidores.split('\n')">{{texto}}</h5>
						</div>
					</div>
					<hr>
					<div class="col-12 mt-2">
						<!-- Redes Sociales -->
						<span class="light-black">Síguenos</span>
						<a class="social-icon" target="_blanck"
						href="https://www.facebook.com/TADEOViajesYTurismo">
							<i class="fab fa-facebook-f"></i>
						</a>
						<a class="social-icon" target="_blanck"
						href="https://www.instagram.com/tadeoviajes_/">
							<i class="fab fa-instagram"></i>
						</a>
						<a class="social-icon" target="_blanck"
						href="https://api.whatsapp.com/send?phone=+524777356737&text=%F0%9F%98%80%20Hola,%20quiero%20mas%20informaci%C3%B3n">
							<i class="fab fa-whatsapp"></i>
						</a>
						<a class="social-icon" target="_blanck"
						href="https://www.youtube.com/channel/UCxv-dKdImum6irtj6zUuosw">
							<i class="fab fa-youtube"></i>
						</a>

						<form action="" class="row p-3">
							<div class="col-8 p-0">
								<input type="email" name="email_subscripcion" [(ngModel)]="email_subscripcion" placeholder="Email" class="input-footer">
							</div>
							<div class="col-4 p-0">
								<button class="btn-footer" (click)="add_subscripcion()">
								    <span class="text-btn-footer">Suscribirme</span>
								    <span class="material-icons-outlined text-btn-send">send</span>
							    </button>
							</div>
						</form>
					</div>
				</div>
			</div>

      <!-- Segunda Columna Footer -->
			<div class="col-12 col-lg-6 p-4">
				<h5><i class="fab fa-instagram"></i> INSTAGRAM</h5>
				<div class="row">
					<div class="col-10">
						<div class="row">
							<a class="col-4 p-0" data-bs-toggle="modal" data-bs-target="#exampleModal" *ngFor="let photo of photos" (click)="imagen(photo.img)">
								<div class="card-insta">
									<img src="{{photo.img}}" class="w-100" alt="{{ photo.img }}">
								</div>
							</a>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12 mt-3">
						<a
						href="https://www.instagram.com/tadeoviajes_/"
						class="light-black"
						target="_blanck">
							VER TODAS LAS FOTOS
						</a>
					</div>
				</div>
			</div>
		</div>
		<hr class="mt-5">
		<div class="row text-center py-3">
			<div class="col-12 text-redirect-footer">
				<span class="material-icons-outlined text-redirect-footer">copyright</span>
				<span> TADEO VIAJES Y TURISMO / <a href="https://cactuslabs.mx" target="_blanck">POWERED BY CACTUS <b>LABS</b></a></span>
			</div>
		</div>
	</article>
</section>

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <button type="button" class="btn-close btn-close-insta" data-bs-dismiss="modal">
      	<span class="material-icons-outlined">close</span>
      </button>
      <div class="modal-body p-0">
        <img class="w-100" src="{{ imagenModal }}" alt="{{ imagenModal }}">
      </div>
    </div>
  </div>
</div>
